window.LiveScheduleAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration['Thoth']);

    self.checkIfBrandHasAvailableShiftsEmailsService = function(brandId) {
        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/settings', 'GET')
            .then(function (res) {
                if (res.data && res.data.data && res.status == 200) {
                    defer.resolve(res.data.data.available_shifts_view_enabled);
                } else {
                    defer.reject(res);
                }
            }).catch(function(err) {
            defer.reject(err);
        });

        return defer.promise;
    };

    self.getPusherSocketAuthToken = async (name, socket_id) => {
        let params = {
            channel_name: name,
            socket_id: socket_id,
        };
        let res = await _protected.request('pusher/users/authenticate', 'POST', params);
        if (!res.data || res.status != 200) {
            throw res;
        }
        return res.data;
    }

});